<template>
  <div class="home">
    <!-- 原body  -->

    <div class="pc" ontouchstart="">
      <div class="wrap">
        <!-- 回到顶部 -->
        <!-- <el-backtop target=".wrap">
          <div class="upFlag">UP</div>
        </el-backtop> -->
        <div class="content">
          <div id="upgrade_notice" class="upgrade__notice">
            为了最好的体验，请升级您的浏览器
          </div>
          <div class="banner">
            <div class="banner__inner" :style="{ 'background-color': backgroundColor }"></div>
            <div class="banner__bd">
              <div class="banner__logo"></div>
              <div class="banner__update-log">
                <ul class="banner__update-list">
                  <li v-for="item in result.topThree" :key="item.flag">
                    <router-link class="banner__update-content" :to="'/log-detail/' + item.id">
                      {{ item.title }}</router-link>
                    <span class="banner__updata-time">{{ item.time }}</span>
                  </li>

                  <!-- <li>
                    <router-link class=banner__update-content to="/log-detail">
                      新增 日志页面 element-ui实现</router-link> 
                      <span class=banner__updata-time>03-12</span>
                  </li>
                  <li> <a class=banner__update-content href=""><span>
                        更新 实现随机切换背景颜色</span></a> 
                        <span class=banner__updata-time>03-11</span> </li>

                  <li> <a class=banner__update-content>
                      新增 OCR文字识别web应用 </a> 
                      <span class=banner__updata-time>03-09</span>
                  </li> -->
                </ul>
                <router-link class="banner__update-more" to="/log">一些日志</router-link>
                <!-- <a class=banner__update-more href="">一些公告</a> -->
              </div>
              <div class="banner__download">
                <a class="banner__download-item" id="android_download" href="https://github.com/wei147" target="_blank">
                  <i class="icon-github"></i>
                  <span>Github</span>
                </a>

                <router-link class="banner__download-item" to="/store" target="_blank">
                  <i class="icon-store"></i>
                  <span>Store</span>
                </router-link>

                <a class="banner__download-item" href="http://120.76.201.89:81/#/video" target="">
                  <i class="icon-video"></i>
                  <span>rpa Video</span>
                </a>

                <!-- <a class="banner__download-item" href="" target=_blank>
                                   <i class=icon-macos></i> <span>macOS</span> </a>
                               <a class="banner__download-item"
                                   href=https:/// target=_blank> <i class=icon-transfer></i>
                                   <span>文件<br>版</span> </a>  -->
              </div>
              <div class="banner__entry-extra-wrp">
                <a href="http://yidou.fun//file/附件简历-魏土金-影刀RPA开发-1年经验.pdf"
                  target="_blank" class="banner__entry-extra banner__entry-extra_watch">
                  <i class="icon-resume"></i>我的简历
                </a>

                <a @click="centerDialogVisible = true" class="banner__entry-extra">
                  <i class="icon-attestation"></i>学籍认证
                </a>
              </div>
            </div>
            <div class="color_change">
              <a href="">{{ colorName }}</a>
              <a @click="changeColor">随机颜色</a>
            </div>
            <div class="banner__arrow"></div>
          </div>
          <div class="links">
            <ul class="links__list">
              <li @click="open">
                <a> <i class="icon-mini-store"></i> 电商项目 </a>
                <!-- <a href="http://120.78.161.175:8083/#/index" target=_blank> <i class=icon-mini-store></i> 电商项目 </a> -->
              </li>
              <li>
                <router-link to="/bmi" target="_blank">
                  <i class="icon-book"></i> BMI计算
                </router-link>
              </li>
              <!-- <li> <a href="" target=_blank> <i class=icon-mini-program></i>OA系统 </a> </li>-->
              <!-- <li> <a href="http://120.78.161.175:81/index" target=_blank> <i class=icon-finder></i> OA系统 </a></li> -->
              <!-- <li>
                <a href="http://120.78.161.175:81/index" target="_blank">
                  <i class="icon-finder"></i> OA系统
                </a>
              </li> -->

              <li>
                <router-link to="/ocr" target="_blank">
                  <i class="icon-mini-ocr"></i> OCR文字识别
                </router-link>
              </li>

              <!-- <li> <a href="" target=_blank> <i class=icon-mini></i> 生成二维码 </a> </li>
              <li> <a href="" target=_blank> 其他 </a> </li> -->
              <li>
                <a target="_blank">
                  个人文档
                </a>
              </li>
            </ul>
          </div>
        </div>
        <!--style-->
        <!--script-->
      </div>
      <!--script-->
    </div>
    <!-- <HelloWorld msg="Welcome to Your Vue.js App" /> -->
  </div>

  <!-- 利用对话框展示学信网在线验证报告 -->
  <el-dialog title="学籍在线认证" v-model="centerDialogVisible" width="40%">
    <span></span>
    <br />
    <a href="http://yidou.fun/file/RPA_yida_certificate.pdf" target="_blank">
      <el-button type="primary" @click="centerDialogVisible = false">
        <el-icon><ArrowLeftBold /></el-icon>RPA证书和钉钉宜搭
      </el-button> </a>&nbsp;&nbsp;
    <a href="https://www.chsi.com.cn/xlcx/bg.do?vcode=AQQ4EGXJE0BTVMLB&trnd=25186839811422033958501779090625&srcid=archive" target="_blank">
      <el-button type="primary" @click="centerDialogVisible = false">全日制本科<el-icon>
          <ArrowRightBold />
        </el-icon>
      </el-button>
    </a>
  </el-dialog>

  <!-- 维护弹框 -->
  <!-- <el-button type="text" @click="open"></el-button> -->
  <div class="footer-wrp">
    <div class="footer">
      <div class="footer__bd">
        <div class="footer__links">
          <a href="#" target="_blank">关于我们</a><span class="graytext"> | </span>
          <a href="#" target="_blank">问题反馈</a>
        </div>
        <a class="footer__record" href="https://beian.miit.gov.cn/#/Integrated/index"
          target="_blank">备案号：粤ICP备2023028282号-1</a>
        <div class="footer__copyright">
          Powered by@wei
        </div>
      </div>
      <div class="clr"></div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

import { ArrowLeftBold, ArrowRightBold } from "@element-plus/icons-vue";
import axios from "axios";
import { onMounted, reactive } from "vue";
import config from '../../my-config.js';

const domain = config.domain;

// import {
//   useRouter
// } from "vue-router"; //引入路由中组件
export default {
  name: "HomeView",
  data() {
    return {
      backgroundColor: "#2177b8",
      colorList: [
        "#2177b8",
        "#22a2c3",
        "#2aae67",
        "#f07c82",
        "#7a7374",
        "#3b818c",
        "#894e54",
        "#35333c",
        "#525288",
        "#8b614d",
      ],
      colorNameList: [
        "虹蓝",
        "海青",
        "微信绿",
        "香叶红",
        "锌灰",
        "蜻蜓蓝",
        "烟红",
        "沙鱼灰",
        "野菊紫",
        "中红灰",
      ],
      colorName: "虹蓝",

      currentNum: 0,
      previousNum: 1,

      // 弹出框
      centerDialogVisible: false,
    };
  },
  components: {
    ArrowLeftBold,
    ArrowRightBold,
  },
  methods: {
    changeColor() {
      const num = Math.floor(Math.random() * this.colorList.length);
      this.backgroundColor = this.colorList[num];
      this.colorName = this.colorNameList[num];
      console.log("颜色数组长度是: " + this.colorList.length);
      console.log(
        "随机数是:" +
        num +
        "   颜色名字是: " +
        this.colorName +
        "  色值是: " +
        this.backgroundColor
      );
    },
    //随机出现选中
    // randomNum() {
    //   let oldIndex, newIndex;
    //   newIndex = Math.floor(Math.random() * 3);
    //   if (newIndex === oldIndex) {
    //     return randomNum()
    //   } else {
    //     oldIndex = newIndex;
    //     return newIndex;
    //   }
    //   console.log(newIndex);
    // }

    // 维护信息
    open() {
      this.$alert("暂不开放,维护中...", "提示", {
        confirmButtonText: "确定",
        // callback: action => {
        //   this.$message({
        //     type: 'info',
        //     message: `action: ${ action }`
        //   });
        // }
      });
    },

    // openvideo() {
    //   this.$alert("预计今晚维护完成", "提示", {
    //     confirmButtonText: "确定",
    //     // callback: action => {
    //     //   this.$message({
    //     //     type: 'info',
    //     //     message: `action: ${ action }`
    //     //   });
    //     // }
    //   });
    // },
  },
};
</script>

<script setup>
let result = reactive({
  topThree: [],
});

onMounted(async () => {
  try {
    axios
      .get(domain + "record/getTopThree", {})
      .then((res) => {
        // console.log(res);
        if (res.data.status == 10000 || res.data.data != null) {
          result.topThree = res.data.data;
          console.log(result);
        } else {
          console.log("获取失败");
        }
      });
  } catch (error) {
    console.log("发生未知的错误");
  }
  return result;
});
</script>

<!-- /* 避免样式污染  */ -->
<style>
.banner__update-log {
  padding: 24px 0 0;
  width: 440px;
  position: relative;
}

.banner__update-log:before {
  content: "";
  display: block;
  border-top: 1px solid hsla(0, 0%, 100%, 0.3);
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
  transform: scaleY(0.5);
  transform-origin: left;
}

.banner__update-log li {
  display: flex;
  margin-bottom: 10px;
}

.banner__update-log li:last-child {
  margin-bottom: 0;
}

.banner__update-log a {
  color: hsla(0, 0%, 100%, 0.9);
}
</style>

<style>
/* 原wcss */

body,
h1,
h2,
h3,
li,
ul {
  padding: 0;
  margin: 0;
}

li,
ul {
  list-style: none;
  margin: 0;
}

body {
  font: 14px/1.6 -apple-system-font, BlinkMacSystemFont, Helvetica Neue,
    PingFang SC, Hiragino Sans GB, Microsoft YaHei UI, Microsoft YaHei, Arial,
    sans-serif;
}

h2 {
  font-size: 14px;
  font-weight: 700;
}

img {
  border: 0;
}

a {
  text-decoration: none;
}

.bold {
  font-weight: 700;
}

.left {
  float: left;
}

.right {
  float: right;
}

.icon-github {
  opacity: 0.8;
  background-image: url("../assets/img/github.png");
  /* background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='40' height='40' viewBox='0 0 40 40'%3E  %3Cdefs%3E    %3Cpath id='a688108f-309f-4e18-a0dc-ed026741fa12-a' d='M0 0h33.684v18.947H0z'/%3E  %3C/defs%3E  %3Cg fill='none' fill-rule='evenodd'%3E    %3Cpath d='M0 0h40v40H0z'/%3E    %3Cg opacity='.8' transform='translate(3.158 11.158)'%3E      %3Cmask id='a688108f-309f-4e18-a0dc-ed026741fa12-b' fill='%23fff'%3E        %3Cuse xlink:href='%23a688108f-309f-4e18-a0dc-ed026741fa12-a'/%3E      %3C/mask%3E      %3Cpath fill='%23FFF' d='M24.594 14.156a1.402 1.402 0 1 1-.003-2.803 1.402 1.402 0 0 1 .003 2.803m-15.504 0a1.402 1.402 0 1 1-.002-2.803 1.402 1.402 0 0 1 .002 2.803M25.097 5.72L27.9.874a.584.584 0 0 0-1.01-.583L24.05 5.2c-2.17-.989-4.608-1.54-7.21-1.54-2.6 0-5.038.552-7.209 1.54L6.794.291a.584.584 0 0 0-1.01.582l2.803 4.848C3.774 8.335.482 13.2 0 18.947h33.684C33.202 13.2 29.91 8.335 25.097 5.721' mask='url(%23a688108f-309f-4e18-a0dc-ed026741fa12-b)'/%3E    %3C/g%3E  %3C/g%3E%3C/svg%3E") */
}

.icon-github,
.icon-store {
  display: inline-block;
  vertical-align: middle;
  width: 40px;
  height: 40px;
  background-size: cover;
}

.icon-store {
  opacity: 0.8;
  background-image: url("../assets/img/store.png");
  /* background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='40' height='40' viewBox='0 0 40 40'%3E  %3Cdefs%3E    %3Cpath id='47f1323c-993c-4d45-aab1-bebb1206c2bb-a' d='M.001.592h26.926v24.039H.001z'/%3E  %3C/defs%3E  %3Cg fill='none' fill-rule='evenodd'%3E    %3Cpath d='M0 0h40v40H0z'/%3E    %3Cg opacity='.8' transform='translate(6.316 2.737)'%3E      %3Cg transform='translate(0 7.045)'%3E        %3Cmask id='47f1323c-993c-4d45-aab1-bebb1206c2bb-b' fill='%23fff'%3E          %3Cuse xlink:href='%2347f1323c-993c-4d45-aab1-bebb1206c2bb-a'/%3E        %3C/mask%3E        %3Cpath fill='%23FFF' d='M20.005.608c-2.722-.193-5.031 1.456-6.32 1.456-1.308 0-3.324-1.415-5.461-1.376-2.806.04-5.393 1.564-6.84 3.972C-1.531 9.506.64 16.687 3.479 20.62c1.389 1.922 3.045 4.088 5.221 4.009 2.094-.08 2.887-1.298 5.418-1.298 2.53 0 3.243 1.298 5.458 1.259 2.254-.04 3.683-1.962 5.061-3.894 1.596-2.23 2.251-4.39 2.29-4.505-.05-.018-4.394-1.614-4.437-6.408-.04-4.008 3.415-5.935 3.573-6.028C24.102.989 21.073.684 20.005.608' mask='url(%2347f1323c-993c-4d45-aab1-bebb1206c2bb-b)'/%3E      %3C/g%3E      %3Cpath fill='%23FFF' d='M18.325 5.057C19.482 3.718 20.26 1.854 20.045 0c-1.663.063-3.676 1.062-4.87 2.4-1.07 1.185-2.008 3.083-1.753 4.899 1.855.137 3.748-.902 4.903-2.242'/%3E    %3C/g%3E  %3C/g%3E%3C/svg%3E") */
}

.icon-video {
  opacity: 0.8;
  width: 30px;
  height: 30px;
  background-image: url("../assets/img/video-fill.png");
  /* background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 40 40'%3E  %3Cg fill='%23FFF' fill-rule='evenodd'%3E    %3Cpath d='M6.316 21.826v9.025l10.99 1.539V21.826zm12.045 0v10.712l14.463 2.026V21.826zM6.316 11.767v9.004h10.99V10.205zM32.824 8l-14.463 2.055v10.716h14.463z' opacity='.8'/%3E    %3Cpath fill='none' d='M0 0h40v40H0z'/%3E  %3C/g%3E%3C/svg%3E") */
}

.icon-macos,
.icon-video {
  display: inline-block;
  vertical-align: middle;
  width: 40px;
  height: 40px;
  background-size: cover;
}

.icon-macos {
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='40' height='40' viewBox='0 0 40 40'%3E  %3Cdefs%3E    %3Cpath id='47f1323c-993c-4d45-aab1-bebb1206c2bb-a' d='M.001.592h26.926v24.039H.001z'/%3E  %3C/defs%3E  %3Cg fill='none' fill-rule='evenodd'%3E    %3Cpath d='M0 0h40v40H0z'/%3E    %3Cg opacity='.8' transform='translate(6.316 2.737)'%3E      %3Cg transform='translate(0 7.045)'%3E        %3Cmask id='47f1323c-993c-4d45-aab1-bebb1206c2bb-b' fill='%23fff'%3E          %3Cuse xlink:href='%2347f1323c-993c-4d45-aab1-bebb1206c2bb-a'/%3E        %3C/mask%3E        %3Cpath fill='%23FFF' d='M20.005.608c-2.722-.193-5.031 1.456-6.32 1.456-1.308 0-3.324-1.415-5.461-1.376-2.806.04-5.393 1.564-6.84 3.972C-1.531 9.506.64 16.687 3.479 20.62c1.389 1.922 3.045 4.088 5.221 4.009 2.094-.08 2.887-1.298 5.418-1.298 2.53 0 3.243 1.298 5.458 1.259 2.254-.04 3.683-1.962 5.061-3.894 1.596-2.23 2.251-4.39 2.29-4.505-.05-.018-4.394-1.614-4.437-6.408-.04-4.008 3.415-5.935 3.573-6.028C24.102.989 21.073.684 20.005.608' mask='url(%2347f1323c-993c-4d45-aab1-bebb1206c2bb-b)'/%3E      %3C/g%3E      %3Cpath fill='%23FFF' d='M18.325 5.057C19.482 3.718 20.26 1.854 20.045 0c-1.663.063-3.676 1.062-4.87 2.4-1.07 1.185-2.008 3.083-1.753 4.899 1.855.137 3.748-.902 4.903-2.242'/%3E    %3C/g%3E  %3C/g%3E%3C/svg%3E");
}

.icon-transfer {
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 40 40'%3E  %3Cg fill='%23FFF'%3E    %3Cpath fill='none' d='M0 0h40v40H0z'/%3E    %3Cpath fill-opacity='.8' d='M15.45 9l2.625 2.1H32.5a1.5 1.5 0 0 1 1.5 1.5v17.3a1.5 1.5 0 0 1-1.5 1.5h-25A1.5 1.5 0 0 1 6 29.9V10.5A1.5 1.5 0 0 1 7.5 9h7.95zm6.67 9.308a.12.12 0 0 0-.12.12v2.193h-8v2.086h8v2.192a.12.12 0 0 0 .199.09l3.371-2.95a.5.5 0 0 0 0-.752l-3.371-2.95a.12.12 0 0 0-.079-.029z'/%3E  %3C/g%3E%3C/svg%3E");
}

.icon-transfer,
.icon-wechat-pay {
  display: inline-block;
  vertical-align: middle;
  width: 40px;
  height: 40px;
  background-size: cover;
}

.icon-wechat-pay {
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 40 40'%3E  %3Cg fill='none' fill-rule='evenodd'%3E    %3Cpath fill='%23FFF' d='M0 40h39.852V0H0z' opacity='0'/%3E    %3Cpath fill='%2307C160' d='M15.382 23.872a1.11 1.11 0 0 1-1.47-.449l-.072-.159-3.034-6.658a.555.555 0 0 1 .835-.68l3.58 2.55a1.658 1.658 0 0 0 1.48.17L33.54 11.15c-3.018-3.558-7.989-5.883-13.614-5.883-9.205 0-16.666 6.218-16.666 13.89 0 4.184 2.244 7.952 5.758 10.499a1.108 1.108 0 0 1 .408 1.258c-.28 1.047-.73 2.723-.75 2.802-.036.131-.09.269-.09.406 0 .307.248.555.556.555a.62.62 0 0 0 .32-.103l3.65-2.107c.274-.158.564-.256.884-.256.171 0 .336.026.49.074 1.702.49 3.54.761 5.44.761 9.205 0 16.667-6.218 16.667-13.89 0-2.322-.688-4.51-1.898-6.435l-19.19 11.08-.122.07z'/%3E  %3C/g%3E%3C/svg%3E");
}

.icon-mini-program {
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 40 40'%3E  %3Cg fill='none' fill-rule='evenodd'%3E    %3Cpath fill='%23FFF' d='M0 40h39.852V0H0z' opacity='0'/%3E    %3Cpath fill='%236467F0' d='M35.377 17.678c-1.133 1.917-3.034 3.392-5.385 4.043-.064 0-.127.064-.19.065a3.24 3.24 0 0 1-1.081.197c-1.591.01-2.489-1.067-2.051-2.406.376-.957 1.262-1.79 2.405-2.178 1.778-.648 2.978-2.12 2.968-3.837-.014-2.291-2.253-4.123-4.99-4.107-2.736.017-4.952 1.876-4.938 4.167l.077 12.729c.019 3.055-1.747 5.738-4.41 7.282-1.46.837-3.175 1.356-4.956 1.367-5.22.032-9.443-3.825-9.472-8.534a7.68 7.68 0 0 1 1.184-4.144c1.134-1.917 3.098-3.393 5.385-4.043.381-.13.826-.196 1.208-.198 1.591-.01 2.489 1.067 2.052 2.406-.313.893-1.2 1.662-2.215 2.114-.127.064-.254.065-.381.13-1.715.646-2.788 2.053-2.778 3.708.014 2.29 2.253 4.123 4.99 4.106 2.736-.017 4.952-1.876 4.938-4.167L17.66 13.65c-.019-3.055 1.747-5.74 4.41-7.283C23.53 5.53 25.244 5.01 27.026 5c5.219-.031 9.443 3.825 9.472 8.535.009 1.527-.428 2.93-1.12 4.143'/%3E  %3C/g%3E%3C/svg%3E");
}

.icon-mini-ocr,
.icon-mini-oa {
  display: inline-block;
  vertical-align: middle;
  width: 40px;
  height: 40px;
  background-size: cover;
}

.icon-mini-ocr {
  margin-left: 3px;
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 40 40'%3E  %3Cg fill='none' fill-rule='evenodd'%3E    %3Cpath fill='%23FFF' d='M0 40h39.851V0H0z' opacity='0'/%3E    %3Cpath fill='%23FA9D3B' d='M25.386 20.626c-1.204 2.243-4.363 2.89-7.055 1.446-2.692-1.445-3.899-4.435-2.695-6.679 1.204-2.244 4.363-2.891 7.055-1.446 2.693 1.445 3.9 4.435 2.695 6.679m.421-8.263C19.493 6.626 10.334 6.42 5.35 11.904c-4.985 5.485-3.907 14.583 2.406 20.32 6.314 5.739 15.473 5.944 20.458.46 4.984-5.485 3.907-14.583-2.407-20.32M31.56 3.46c2.463-.645 5.087 1.23 5.86 4.186.773 2.956-.597 5.875-3.061 6.52-2.463.643-5.087-1.23-5.86-4.187-.773-2.956.597-5.875 3.06-6.52'/%3E  %3C/g%3E%3C/svg%3E");
}

.icon-mini-oa {
  margin-left: 3px;
  background-image: url("../assets/img/folder.png");
}

.icon-mini-store {
  margin-left: 8px;
  background-image: url("data:image/png;base64,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");
}

.icon-mini-store,
.icon-wecom {
  display: inline-block;
  vertical-align: middle;
  width: 40px;
  height: 40px;
  background-size: cover;
}

.icon-wecom {
  background-image: url("data:image/png;base64,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");
}

.icon-sticker {
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='80' height='80' viewBox='0 0 80 80'%3E  %3Cg fill='none'%3E    %3Cpath fill='%23FFF' d='M0 0h80v80H0z' opacity='0'/%3E    %3Cpath fill='%23FFC300' d='M40 8.667c18.41 0 33.333 13.942 33.333 31.142C73.333 57.008 58.41 70.95 40 70.95c-5.598 0-10.873-1.29-15.505-3.567l-.005.03c-7.52-3.677-10.974-.769-14.936-1.982-3.233-.99-1.255-3.729-1.255-3.729 3.596-3.782 1.78-8.097 1.78-8.097l.034.008A29.356 29.356 0 0 1 6.667 39.81C6.667 22.609 21.59 8.667 40 8.667zm17.98 19.711a3.808 3.808 0 0 0 3.806-3.81 3.809 3.809 0 0 0-3.806-3.812 3.809 3.809 0 0 0-3.805 3.811 3.808 3.808 0 0 0 3.805 3.811zm-7.875 25.49c3.262 0 5.905-8.765 5.905-19.578v-.132H44.2v.132c0 10.813 2.644 19.579 5.905 19.579zm-8.662-25.49a3.81 3.81 0 0 0 3.809-3.81 3.81 3.81 0 0 0-3.809-3.812 3.81 3.81 0 0 0-3.808 3.811 3.81 3.81 0 0 0 3.808 3.811z'/%3E  %3C/g%3E%3C/svg%3E");
}

.icon-red-pocket,
.icon-sticker {
  display: inline-block;
  vertical-align: middle;
  width: 40px;
  height: 40px;
  background-size: cover;
}

.icon-red-pocket {
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='80' height='80' viewBox='0 0 80 80'%3E  %3Cg fill='none'%3E    %3Cpath fill='%23FFF' d='M0 0h80v80H0z' opacity='0'/%3E    %3Cpath fill='%23FA5151' d='M66.667 43.579h-7.122a7.203 7.203 0 0 0 .788-3.287c0-4.034-3.305-7.292-7.368-7.292a7.39 7.39 0 0 0-5.28 2.206L40 42.784l-7.852-7.741A7.411 7.411 0 0 0 27.036 33c-4.063 0-7.37 3.258-7.37 7.292 0 1.183.285 2.3.79 3.287h-7.123v-27.55c0-1.845 1.308-4.015 2.98-4.833 0 0-.682.28.587-.263 6.218-2.66 14.285-4.266 23.1-4.266 8.804 0 16.861 1.601 23.076 4.255 1.278.546.591.265.591.265 1.657.83 3 2.998 3 4.843v27.549zm0 4V70a3.324 3.324 0 0 1-3.337 3.333H16.67A3.332 3.332 0 0 1 13.333 70V47.579h13.39c.103.004.208.006.313.006h8.093c-2.821 2.758-7.162 6.372-13.008 10.824l2.424 3.182c6.081-4.632 10.593-8.397 13.554-11.315l1.9-1.875 1.944 1.915c2.951 2.91 7.45 6.662 13.512 11.276l2.423-3.184c-5.855-4.455-10.196-8.07-13.008-10.823h8.095c.105 0 .21-.002.313-.006h13.389zm-13.489-4h-8.287l5.624-5.546A3.41 3.41 0 0 1 52.965 37c1.867 0 3.368 1.48 3.368 3.292 0 1.743-1.388 3.179-3.155 3.287zm-26.356 0c-1.766-.108-3.155-1.544-3.155-3.287 0-1.811 1.502-3.292 3.369-3.292.886 0 1.713.334 2.336.922l5.737 5.657h-8.287z'/%3E  %3C/g%3E%3C/svg%3E");
}

.icon-open-platform {
  background-image: url("data:image/png;base64,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");
}

.icon-open-platform,
.icon-service {
  display: inline-block;
  vertical-align: middle;
  width: 40px;
  height: 40px;
  background-size: cover;
}

.icon-service {
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='80' height='80' viewBox='0 0 80 80'%3E  %3Cg fill='none'%3E    %3Cpath fill='%23FFF' d='M0 0h80v80H0z' opacity='0'/%3E    %3Cpath fill='%238385F3' d='M19.53 41.519L9.113 64.637c1.636 1.358 3.878 2.198 6.355 2.198.762 0 1.498-.088 2.205-.24.47-.1.931-.223 1.37-.382l.011-.002.016-.008a9.337 9.337 0 0 0 2.77-1.58c.896-.747 1.607-1.646 2.074-2.654l2.414-5.357-6.8-15.093z'/%3E    %3Cpath fill='%2307C160' d='M27.32 18.996c-.48-.998-1.208-1.888-2.127-2.628a9.647 9.647 0 0 0-2.838-1.564l-.017-.009-.01-.002a11.059 11.059 0 0 0-3.664-.616c-2.538 0-4.835.832-6.512 2.178l21.26 45.653c.478.998 1.236 1.896 2.154 2.636a9.655 9.655 0 0 0 2.839 1.564l.016.01h.011c1.125.396 2.362.617 3.664.617 2.537 0 4.835-.831 6.512-2.177L27.319 18.996z'/%3E    %3Cpath fill='%238385F3' d='M45.547 18.996c-.478-.998-1.208-1.888-2.126-2.628a9.647 9.647 0 0 0-2.839-1.564l-.016-.009-.01-.002a11.059 11.059 0 0 0-3.664-.616c-2.538 0-4.835.832-6.512 2.178l21.268 45.671c.479.998 1.228 1.878 2.146 2.618a9.655 9.655 0 0 0 2.839 1.564l.016.01h.011c1.125.396 2.362.617 3.663.617 2.538 0 4.836-.831 6.512-2.177L45.547 18.996z'/%3E    %3Cpath fill='%2307C160' d='M59.458 39.494l10.415-23.118c-1.636-1.358-3.878-2.199-6.354-2.199-.763 0-1.498.09-2.206.24-.47.1-.93.223-1.37.382l-.01.002-.017.009a9.323 9.323 0 0 0-2.77 1.58c-.895.747-1.607 1.645-2.074 2.653l-2.414 5.358 6.8 15.093z'/%3E  %3C/g%3E%3C/svg%3E");
}

.icon-book {
  background-image: url("../assets/img/checklist.png");
  /* background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='80' height='80' viewBox='0 0 80 80'%3E  %3Cg fill='none'%3E    %3Cpath fill='%23FFF' d='M0 0h80v80H0z' opacity='0'/%3E    %3Cpath fill='%2307C160' d='M60.962 22.753c-7.601-2.567-18.054-2.99-27.845 4.49-5.423 4.539-9.56 10.715-10.675 18.567-2.958-3.098-5.025-7.995-5.58-11.706-.806-5.403.483-10.82 4.311-15.45C26.906 11.724 34.577 10 39.6 10c9.57.001 18.022 5.882 21.363 12.753zm7.64 11.78c7.516 9.754 5.441 24.73-5.1 32.852-2.618 2.018-5.67 3.198-8.651 4.024a26.067 26.067 0 0 0 5.668-9.54c4.613-13.806-2.868-28.821-16.708-33.536-.3-.102-.601-.191-.903-.282 9.348-3.467 19.704-1.292 25.694 6.482zM39.572 59.37c6.403 0 11.474-1.49 16.264-5.013-.124 1.993-.723 4.392-1.271 5.805-4.509 11.633-17.56 16.676-31.238 12.183C11.433 68.438 4.145 54.492 7.475 42.851c.893-3.12 1.805-5.26 3.518-7.953 1.028 7.504 5.7 14.803 12.511 19.448.518.35.872.932.901 1.605a2.4 2.4 0 0 1-.08.653l-1.143 5.19c-.052.243-.142.499-.13.752.023.56.495.997 1.053.973.22-.01.395-.1.576-.215l6.463-4.143c.486-.312 1.007-.513 1.587-.538a3.03 3.03 0 0 1 .742.067c1.96.438 3.996.68 6.1.68z'/%3E  %3C/g%3E%3C/svg%3E") */
}

.icon-book,
.icon-wedesign {
  display: inline-block;
  vertical-align: middle;
  width: 40px;
  height: 40px;
  background-size: cover;
}

.icon-wedesign {
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='40' height='40' viewBox='0 0 40 40'%3E  %3Cdefs%3E    %3Cpath id='11e4853f-c516-4e74-bd75-b4c716c464bf-a' d='M0 0h33.333v33.333H0z'/%3E  %3C/defs%3E  %3Cg fill='none' fill-rule='evenodd'%3E    %3Cpath fill='%23D8D8D8' fill-rule='nonzero' d='M0 0h40v40H0z' opacity='0'/%3E    %3Cg transform='translate(3.333 3.333)'%3E      %3Cpath fill='%23333' fill-rule='nonzero' d='M19.822 10.434h-1.858v10.568a1.86 1.86 0 0 0 1.858 1.858 1.86 1.86 0 0 0 1.857-1.858v-8.71a1.86 1.86 0 0 0-1.857-1.858'/%3E      %3Cmask id='11e4853f-c516-4e74-bd75-b4c716c464bf-b' fill='%23fff'%3E        %3Cuse xlink:href='%2311e4853f-c516-4e74-bd75-b4c716c464bf-a'/%3E      %3C/mask%3E      %3Cpath fill='%23333' fill-rule='nonzero' d='M24.275 21.042a4.458 4.458 0 0 1-4.453 4.413 4.439 4.439 0 0 1-3.134-1.292l-.028.028a4.424 4.424 0 0 1-3.149 1.304 4.458 4.458 0 0 1-4.453-4.453v-9.295h2.596v9.295a1.86 1.86 0 0 0 3.171 1.313c.35-.35.544-.817.544-1.313V7.838h4.453a4.458 4.458 0 0 1 4.453 4.445v8.759zM10.002 8.423a.479.479 0 0 1 .04-.06.393.393 0 0 1 .313-.168c.12 0 .227.059.304.153l.051.08.925 2.004H9.077l.925-2.009zM16.667 0C7.462 0 0 7.462 0 16.667c0 9.204 7.462 16.666 16.667 16.666 9.204 0 16.666-7.462 16.666-16.666C33.333 7.462 25.871 0 16.667 0z' mask='url(%2311e4853f-c516-4e74-bd75-b4c716c464bf-b)'/%3E    %3C/g%3E  %3C/g%3E%3C/svg%3E");
}

.icon-search {
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 40 40'%3E  %3Cg fill='none'%3E    %3Cpath fill='%23FFF' d='M0 0h40v40H0z' opacity='0'/%3E    %3Cpath fill='%23FA5151' d='M21.598 7.428c.28-.583.301-1.215.061-1.78-.24-.564-.712-.988-1.328-1.191l-.519-.172a2.3 2.3 0 0 0-.723-.119c-1.018 0-1.872.718-2.076 1.745l-1.085 5.455c-.261 1.31.127 2.535.884 2.785a.979.979 0 0 0 .31.048c.724 0 1.575-.72 2.07-1.752l2.406-5.018zm-8.586 9.164c.075-.79-.883-1.658-2.182-1.977l-3.995-.982a2.328 2.328 0 0 0-.554-.07c-1.088 0-1.954.808-2.061 1.92l-.053.563c-.006.679.222 1.286.642 1.71.379.381.88.583 1.45.583l.125-.003 4.11-.213c1.336-.07 2.441-.741 2.518-1.53m1.589 4.172c-.751-.249-1.785.532-2.314 1.74l-3.803 8.687a2.204 2.204 0 0 0-.008 1.8c.253.57.73.996 1.345 1.2l.519.173.051.01c.085.008.174.012.267.012 1.081 0 2.29-.5 2.556-1.62l2.19-9.223c.31-1.305-.043-2.526-.803-2.779M22.01 22.2c-.622-.663-1.41-1.075-2.056-1.075-.275 0-.516.078-.698.225-.624.505-.51 1.762.26 2.864l7.444 10.642a2.237 2.237 0 0 0 1.85.977c.521 0 1.017-.178 1.434-.515l.424-.343c.503-.406.803-.974.847-1.6a2.237 2.237 0 0 0-.618-1.7L22.01 22.2zm13.79-6.71a2.2 2.2 0 0 0-2.55-2.076l-11.02 1.605c-1.33.194-2.336.97-2.29 1.77.044.8 1.134 1.442 2.48 1.463l10.885.142h.04a2.65 2.65 0 0 0 1.896-.812 2.08 2.08 0 0 0 .59-1.546l-.032-.545z'/%3E  %3C/g%3E%3C/svg%3E");
}

.icon-openai,
.icon-search {
  display: inline-block;
  vertical-align: middle;
  width: 40px;
  height: 40px;
  background-size: cover;
}

.icon-openai {
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 40 40'%3E  %3Cg fill='none'%3E    %3Cpath fill='%23FFF' d='M0 40h40V0H0z' opacity='0'/%3E    %3Cpath fill='%23F95151' d='M5.977 17.525c-2.294-3.842-.191-9.858 6.818-11.883 13.158-3.801 25.825 10.8 25.825 10.8s-10.4-3.976-20.542 3.084c-2.84 1.976-9.192 2.875-12.101-2'/%3E    %3Cpath fill='%23F95151' d='M34.023 22.558c2.294 3.842.191 9.859-6.818 11.883C14.047 38.243 1.38 23.642 1.38 23.642s10.4 3.975 20.542-3.085c2.84-1.976 9.192-2.874 12.101 2.001'/%3E  %3C/g%3E%3C/svg%3E");
}

.icon-resume {
  opacity: 0.8;
  background-image: url("../assets/img/resume.png");
  /* background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32'%3E  %3Cg fill='%23FFF' fill-rule='evenodd' opacity='.8'%3E    %3Cpath d='M0 32h32V0H0z' opacity='0'/%3E    %3Cpath d='M16.5 6.429a1.214 1.214 0 1 0 0 2.427 1.214 1.214 0 0 0 0-2.427zm4.515 3.642h-9.03c-.541 0-.737.056-.935.163a1.1 1.1 0 0 0-.459.46c-.092.172-.148.344-.16.746l-.002.188v9.03c0 .541.055.737.162.935a1.1 1.1 0 0 0 .46.459c.172.092.344.146.747.16l.187.002h9.03c.541 0 .738-.057.936-.162.197-.106.352-.261.459-.46.092-.172.147-.344.159-.747l.002-.187v-9.03c0-.541-.055-.737-.161-.935a1.115 1.115 0 0 0-.46-.459c-.197-.107-.394-.163-.935-.163zM18.559 4c1.007 0 1.374.093 1.749.274a2.2 2.2 0 0 1 .907.8c.226.352.364.703.49 1.702l.11.884c.84.044 1.235.176 1.632.388.494.265.883.652 1.147 1.147.265.496.406.986.406 2.34v9.216c0 1.353-.14 1.843-.406 2.339a2.766 2.766 0 0 1-1.147 1.147c-.397.213-.792.345-1.632.389l-.11.884c-.126.998-.264 1.349-.49 1.7-.226.35-.53.62-.907.8-.345.166-.681.259-1.51.273l-.239.003h-4.118c-1.007 0-1.373-.094-1.749-.276a2.19 2.19 0 0 1-.907-.8c-.208-.32-.341-.644-.458-1.465l-.031-.235-.11-.884c-.841-.044-1.236-.176-1.633-.389a2.766 2.766 0 0 1-1.147-1.147C8.14 22.594 8 22.104 8 20.75v-9.216c0-1.354.14-1.844.406-2.34a2.763 2.763 0 0 1 1.147-1.147c.397-.212.792-.344 1.633-.388l.11-.884c.125-1 .263-1.35.489-1.701.227-.351.53-.62.907-.8.376-.182.742-.275 1.749-.275h4.118z'/%3E  %3C/g%3E%3C/svg%3E") */
}

.icon-attestation,
.icon-resume {
  display: inline-block;
  vertical-align: middle;
  width: 32px;
  height: 32px;
  background-size: cover;
}

.icon-attestation {
  opacity: 0.8;
  background-image: url("../assets/img/attestation.png");
  /* background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32'%3E  %3Cg fill='%23FFF' fill-rule='evenodd' opacity='.8'%3E    %3Cpath d='M0 32h32V0H0z' opacity='0'/%3E    %3Cpath d='M15.929 7.785c-1.55 0-3.134.07-4.754.209a2.743 2.743 0 0 0-2.314 1.72l-.026.067-1.064 2.898h16.073l-1.065-2.907a2.742 2.742 0 0 0-2.262-1.78l-.072-.008a51.185 51.185 0 0 0-4.516-.2zM6.596 14.57l-.028.034-.025.031a2.74 2.74 0 0 0-.519 1.077l-.02.09-.009.047c-.087.44.119.886.51 1.106.345.194.663.328.954.4.672.17 1.202.259 2.085.154l.108-.014.041-.007a.474.474 0 0 0 .242-.788l-.028-.027-2.383-2.15a.657.657 0 0 0-.928.047zm17.852-.075a.536.536 0 0 0-.033.028l-2.383 2.15a.474.474 0 0 0 .214.815l.042.007c.948.126 1.493.037 2.192-.14a3.93 3.93 0 0 0 .954-.4c.392-.22.597-.666.51-1.106l-.01-.046a2.746 2.746 0 0 0-.538-1.168l-.025-.031a.657.657 0 0 0-.923-.109zm2.335 4.918l-.03.001-.028.004-.079.015c-1.384.255-2.665.683-2.763.714-.06.019-.08.068-.06.148l.007.028h2.544l.01.022c.05.116.07.344.057.684a6.516 6.516 0 0 1-.134 1.088c.253-.138.462-.462.627-.97.12-.37.189-.747.205-1.135l.004-.13v-.118l-.002-.032a.356.356 0 0 0-.358-.32zm-21.566 0a.356.356 0 0 0-.358.319l-.002.032v.118c.006.434.076.855.209 1.264.165.51.374.833.627.97a6.516 6.516 0 0 1-.134-1.087c-.012-.34.006-.568.056-.684l.01-.022H8.17c.032-.096.014-.155-.053-.176-.098-.03-1.38-.459-2.763-.714l-.079-.015-.029-.004-.03-.001zm16.593 1.655H10.19c-.393 0-.76.197-.977.524a.337.337 0 0 0 .249.523l.032.002h13.012a.338.338 0 0 0 .281-.525 1.173 1.173 0 0 0-.977-.524zM15.937 7.086c1.555 0 3.103.064 4.644.191 1.296.108 2.42.94 2.902 2.148l1.199 3.011.2-.15a1.5 1.5 0 0 1 .009-.213l.01-.07c.04-.25.148-.506.323-.767a.685.685 0 0 1 .558-.305h.106c.28.005.537.048.77.129.276.096.54.264.793.505a.69.69 0 0 1 .212.496v.277c0 .336-.246.62-.578.669-.141.02-.283.035-.426.045-.303.019-.752.02-1.344.006l1.85 1.352a3.086 3.086 0 0 1 1.248 2.159c.106.972.158 1.95.158 2.934 0 1.353-.099 2.706-.298 4.058l-.04.424a1.028 1.028 0 0 1-1.025.93h-1.685a1.03 1.03 0 0 1-1.029-1.03v-.02H7.506v.02c0 .569-.46 1.03-1.029 1.03H4.81a1.03 1.03 0 0 1-1.024-.93l-.012-.12h-.001a28.196 28.196 0 0 1-.344-4.362c0-1.01.056-2.018.169-3.028.09-.81.497-1.55 1.13-2.06l1.684-1.356a15.94 15.94 0 0 1-1.3-.007 5.306 5.306 0 0 1-.426-.045.676.676 0 0 1-.578-.669v-.277c0-.187.077-.367.213-.496.252-.241.516-.41.792-.505a2.47 2.47 0 0 1 .77-.129h.106a.685.685 0 0 1 .559.305c.175.261.282.517.323.767.015.093.021.188.018.283l.08.06L8.13 9.435a3.429 3.429 0 0 1 2.908-2.147c1.668-.135 3.3-.202 4.899-.202z'/%3E  %3C/g%3E%3C/svg%3E") */
}

.icon-edu {
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 40 40'%3E  %3Cg fill='none' fill-rule='evenodd' transform='translate(2 4.5)'%3E    %3Cpath fill='%2307C160' d='M16.487 19.032c-3.645-3.645-4.374-9.097-2.192-13.466-5-.165-9.927 2.361-12.604 6.997a13.983 13.983 0 0 0-1.64 4.423 3.256 3.256 0 0 0 2.787 3.804 23.195 23.195 0 0 1 15.415 8.9l.12.148a3.257 3.257 0 0 0 4.576.354l.045-.039a14.014 14.014 0 0 0 4.605-8.057c-3.85.969-8.1-.051-11.112-3.064'/%3E    %3Cpath fill='%235152C0' d='M20.824 7.436a13.955 13.955 0 0 0-6.53-1.87c-2.18 4.368-1.452 9.822 2.193 13.465a11.665 11.665 0 0 0 11.112 3.066c1.04-5.664-1.503-11.617-6.775-14.66'/%3E    %3Cpath fill='%231485EE' d='M33.984 12.234a3.615 3.615 0 0 0-.145-.065A19.345 19.345 0 0 1 23.349 1.68 2.712 2.712 0 0 0 19.682.26l-.055.027a11.615 11.615 0 0 0-4.532 3.92c2.199.181 4.393.839 6.432 2.015 5.57 3.216 8.371 9.384 7.57 15.388a11.62 11.62 0 0 0 3.892-2.573 11.648 11.648 0 0 0 2.242-3.145c.006-.012.025-.049.027-.056a2.714 2.714 0 0 0-1.274-3.602'/%3E  %3C/g%3E%3C/svg%3E");
}

.icon-edu,
.icon-finder {
  display: inline-block;
  vertical-align: middle;
  width: 40px;
  height: 40px;
  background-size: cover;
}

.icon-finder {
  /* background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 40 40'%3E  %3Cg fill='none' fill-rule='evenodd'%3E    %3Cpath fill='%23FFF' d='M0 0h40v40H0z' opacity='0'/%3E    %3Cpath fill='%23FA9D3B' d='M32.99 5.676c.784.06 2.228.47 3.092 2.559 1.191 2.88.296 8.516-.344 11.619-.966 4.685-2.522 9.352-3.964 11.889-.96 1.687-1.918 2.548-3.016 2.708a3.703 3.703 0 0 1-.535.039c-3.247 0-6.338-4.24-8.223-7.47-1.885 3.23-4.977 7.47-8.223 7.47a3.69 3.69 0 0 1-.534-.039c-1.1-.16-2.058-1.02-3.017-2.708-1.442-2.537-2.998-7.204-3.964-11.89-.64-3.102-1.535-8.737-.344-11.618.864-2.089 2.308-2.5 3.092-2.559 2.913-.216 6.377 3.365 11.564 11.976.525.87 1.009 1.68 1.426 2.38.42-.704.904-1.514 1.426-2.38C26.612 9.043 30.06 5.458 32.989 5.676zM7.13 9.471l-.04.076-.049.13c-.636 1.825-.171 6.682 1.154 11.951 1.274 5.064 2.654 7.922 3.373 9.007a.63.63 0 0 0 .824.213c.634-.339 1.739-1.227 3.335-3.549 1-1.455 1.828-2.948 2.305-3.855a633.97 633.97 0 0 0-2.4-4.02c-4.51-7.488-6.896-9.545-7.856-10.11a.478.478 0 0 0-.646.157zm25.775.068a.462.462 0 0 0-.675-.23c-.952.558-3.34 2.604-7.863 10.115a629.316 629.316 0 0 0-2.406 4.028c1.93 3.76 4.149 6.497 5.499 7.336a.741.741 0 0 0 1.017-.221c.727-1.13 2.077-3.975 3.326-8.939 1.359-5.4 1.813-10.369 1.105-12.08z'/%3E  %3C/g%3E%3C/svg%3E") */
  background-image: url("../assets/img/folder.png");
}

* {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-tap-highlight-color: transparent;
}

body,
html {
  height: 100%;
}

body {
  background: #f7f7f7;
  font-size: 17px;
  width: 100%;
  margin: 0;
  color: rgba(0, 0, 0, 0.9);
}

@font-face {
  font-family: micross;
  src: url(data:application/x-font-ttf;charset=utf-8;base64,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) format("truetype");
}

@keyframes a {
  0% {
    opacity: 0;
    transform: translateY(50px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.wrap {
  position: relative;
  min-height: 100%;
  overflow: hidden;
}

.content {
  background: none;
  margin: 0;
  border: none;
  border-radius: 0;
  position: relative;
}

.upgrade__notice {
  line-height: 48px;
  background-color: #ededed;
  font-size: 15px;
  display: none;
  color: rgba(0, 0, 0, 0.7);
  text-align: center;
}

.banner {
  padding: 152px 0 112px;
  position: relative;
  color: hsla(0, 0%, 100%, 0.9);
  overflow: hidden;
}

.color_change {
  font-size: 16px;
  line-height: 1;
  position: absolute;
  top: 32px;
  right: 32px;
  display: flex;
}

.color_change a {
  padding: 0 8px;
  cursor: pointer;
  color: hsla(0, 0%, 100%, 0.6);
}

.color_change a:hover {
  transition: color 0.3s;
  color: hsla(0, 0%, 100%, 0.9);
}

.color_change a+a {
  border-left: 1px solid hsla(0, 0%, 100%, 0.3);
}

.color_change a.current {
  color: hsla(0, 0%, 100%, 0.9);
}

.banner__inner {
  content: "";
  display: block;
  position: absolute;
  height: 100%;
  bottom: 0;
  width: 150%;
  min-width: 1440px;
  left: 50%;
  transform: translateX(-50%);
  /* 控制背景颜色的地方 */
  /* background-color: #22a2c3; 海青 */
  background-color: #2aae67;
  border-radius: 0 0 50% 50%;
  z-index: -1;
  overflow: hidden;
}

.banner__inner img {
  position: aboslute;
  width: 100%;
  bottom: 0;
  left: 0;
}

.banner__bd {
  display: flex;
  flex-direction: column;
  align-items: center;
  animation: a 1.3s both;
}

.banner__logo {
  margin: 0 auto 56px;
  display: block;
  display: inline-block;
  vertical-align: middle;
  width: 154px;
  height: 48px;
  background-size: cover;
  background-image: url("../assets/img/test1.png");
  /* background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='154' height='48' viewBox='0 0 154 48'%3E  %3Cg fill='%23FFF' fill-rule='evenodd' opacity='.9'%3E    %3Cpath d='M52.629 42.213c3.73-2.706 6.113-6.709 6.113-11.157 0-8.152-7.921-14.76-17.694-14.76-9.77 0-17.693 6.608-17.693 14.76 0 8.153 7.922 14.761 17.693 14.761 2.02 0 3.969-.289 5.776-.809.165-.05.339-.078.52-.078.34 0 .648.104.94.272l3.872 2.24c.109.06.214.11.342.11a.59.59 0 0 0 .59-.59c0-.148-.059-.293-.095-.433l-.798-2.977a1.413 1.413 0 0 1-.062-.376c0-.397.196-.749.496-.963M35.15 28.544a2.21 2.21 0 1 1 0-4.422 2.21 2.21 0 0 1 0 4.422m11.795 0c-1.22 0-2.208-.99-2.208-2.21a2.21 2.21 0 1 1 4.418 0 2.21 2.21 0 0 1-2.21 2.21'/%3E    %3Cpath d='M21.232 0C9.506 0 0 7.93 0 17.712c0 5.338 2.86 10.142 7.336 13.389.36.257.595.678.595 1.155 0 .157-.034.3-.075.451l-.957 3.573c-.044.168-.114.342-.114.518 0 .391.317.708.708.708.154 0 .28-.057.408-.132l4.65-2.687c.349-.2.718-.325 1.126-.325.218 0 .427.032.624.092a25.087 25.087 0 0 0 8.097.944 13.658 13.658 0 0 1-.713-4.341c0-8.921 8.669-16.155 19.364-16.155.387 0 .486.013.867.031C40.317 6.471 31.824 0 21.232 0m-7.077 14.557a2.512 2.512 0 0 1 0-5.025 2.511 2.511 0 0 1 2.51 2.513 2.512 2.512 0 0 1-2.51 2.512m14.154 0a2.511 2.511 0 0 1-2.51-2.512 2.511 2.511 0 0 1 2.51-2.513 2.511 2.511 0 0 1 2.51 2.513 2.511 2.511 0 0 1-2.51 2.512'/%3E    %3Cg transform='translate(70.845 5.408)'%3E      %3Cpath d='M52.878.625l2.839 1.116a70.416 70.416 0 0 1-2.826 8.145V37.67h-2.98V15.846a60.717 60.717 0 0 1-3.288 4.913l-2.288-2.117c3.744-4.905 6.902-11.179 8.543-18.017M68.793.54a176.643 176.643 0 0 1 2.795 5.289h10.735v2.857H55.79V5.83h12.33c-.777-1.43-1.517-2.822-2.047-3.72l2.72-1.57zm-9.804 14.229h20.36v-2.613h-20.36zm0 6.042h20.36v-2.654h-20.36zm3.061 13.133h14.238v-7.01H62.05v7.01zM58.99 24.2v12.45h20.358V24.2H58.99zM7.893 10l2.421 1.377c-.752 1.63-1.267 2.663-2.311 4.418l.024 21.87H5.27l-.024-17.693c-1.128 1.545-1.84 2.447-2.968 3.7l-2.174-2.03C2.93 18.708 6.013 14.095 7.893 10M7.436.67l2.547 1.454c-1.837 3.3-5.012 7.644-7.81 10.777L0 10.896C2.715 7.93 5.765 3.802 7.436.669m3.984 16.975h12.945v-2.657H11.42zm3.192-14.162v6.364h2.559V.545h2.685v9.301h2.559V3.473l2.646.007v8.88H12.085V3.48zm11.996 22.084s-2.111 2.015-2.71 2.53v-7.579h-11.32l-.002 5.86c0 4.221-.942 6.07-2.711 7.983l2.03 1.886c2.758-2.988 3.343-5.362 3.343-9.298v-3.714l5.982-.001s.114 6.504-.086 7.498l1.81 1.691s4.301-3.905 5.625-5.023l-1.96-1.833z'/%3E      %3Cpath d='M32.848 22.844c-1.377-3.323-1.99-5.2-2.825-8.772.411-1.388.81-3.605.966-5.442h4.123c-.206 6.075-.98 10.826-2.264 14.214m1.585 3.186c1.928-4.177 3.025-9.923 3.123-17.401l1.85.003V5.826l-8.02.01c.104-1.55.071-3.324.071-4.308h-2.582c.032 3.98-.412 7.775-.992 10.444-.647 2.976-1.677 5.866-2.822 7.586l2.01 1.798c.575-.91 1.062-1.813 1.664-3.112 1.04 3.777 1.504 4.813 2.784 7.69a47.754 47.754 0 0 1-6.24 9.653l2.18 1.927c1.062-1.314 3.419-4.47 5.597-8.688.98 1.833 3.032 5.038 5.432 8.627l2.174-2.215c-1.95-2.447-4.651-6.193-6.229-9.208'/%3E    %3C/g%3E  %3C/g%3E%3C/svg%3E") */
}

/* 为了避免css样式污染已转移到上面 */
/* 
  .banner__update-log {
    padding: 24px 0 0;
    width: 440px;
    position: relative
  }

  .banner__update-log:before {
    content: "";
    display: block;
    border-top: 1px solid hsla(0, 0%, 100%, .3);
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
    transform: scaleY(.5);
    transform-origin: left 
  }

  .banner__update-log li {
    display: flex;
    margin-bottom: 10px
  }

  .banner__update-log li:last-child {
    margin-bottom: 0
  }

  .banner__update-log a {
    color: hsla(0, 0%, 100%, .9)
  } */

.banner__update-content {
  flex: 1;
  display: flex;
  overflow: hidden;
  align-items: center;
  line-height: 1.4;
}

.banner__update-content span {
  display: inline-block;
}

.banner__updata-time {
  color: hsla(0, 0%, 100%, 0.7);
  margin-left: 16px;
  font-variant-numeric: tabular-nums;
  font-family: -apple-system-font, BlinkMacSystemFont, Helvetica Neue,
    PingFang SC, micross, monospace;
}

.banner__update-more {
  margin-top: 16px;
  display: inline-block;
  color: hsla(0, 0%, 100%, 0.9);
}

.banner__update-more:after {
  content: ">";
  display: inline-block;
  margin-left: 5px;
}

.banner__update-more:hover {
  font-weight: 500;
}

.banner__download {
  margin-top: 72px;
  display: flex;
  align-items: center;
  margin-right: -24px;
}

.banner__download-item {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background-color: hsla(0, 0%, 100%, 0.07);
  color: hsla(0, 0%, 100%, 0.9);
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 24px;
  font-size: 14px;
  cursor: pointer;
}

.banner__download-item i {
  margin-bottom: 4px;
  margin-top: 26px;
}

.banner__download-item span {
  margin: 0 10px;
  text-align: center;
  line-height: 1.4;
}

.banner__download-item:hover {
  background-color: hsla(0, 0%, 100%, 0.15);
}

.banner__entry-extra-wrp {
  display: flex;
  justify-content: center;
  padding-top: 56px;
}

.banner__entry-extra {
  width: 205px;
  height: 56px;
  display: flex;
  background-color: #fff;
  background-color: hsla(0, 0%, 100%, 0.07);
  color: hsla(0, 0%, 100%, 0.9);
  border-radius: 8px;
  align-items: center;
  justify-content: center;
}

.banner__entry-extra:hover {
  background-color: hsla(0, 0%, 100%, 0.15);
}

.banner__entry-extra i {
  margin-right: 8px;
  margin-top: -3px;
}

.banner__entry-extra+.banner__entry-extra {
  margin-left: 24px;
}

@keyframes b {
  0% {
    opacity: 0;
  }

  to {
    opacity: 0.5;
    transform: translateX(-50%) translateY(7px);
  }
}

.banner__arrow {
  animation: b 1s 1s infinite;
  opacity: 0;
  display: none;
  position: absolute;
  vertical-align: middle;
  width: 24px;
  height: 12px;
  background-size: cover;
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='24' height='12' viewBox='0 0 24 12'%3E  %3Cdefs%3E    %3Cpath id='2883de6b-9b56-4ce9-a5b1-606b3650aa1f-a' d='M.021 1.486l4.949 4.95-4.949 4.95 1.414 1.413 5.657-5.658a1 1 0 0 0 0-1.414L1.435.072.021 1.486z'/%3E  %3C/defs%3E  %3Cg fill='none' fill-rule='evenodd' transform='rotate(90 12 12)'%3E    %3Cpath fill='%23FFF' d='M0 0h12v24H0z' opacity='0'/%3E    %3Cg transform='translate(3 5.5)'%3E      %3Cmask id='2883de6b-9b56-4ce9-a5b1-606b3650aa1f-b' fill='%23fff'%3E        %3Cuse xlink:href='%232883de6b-9b56-4ce9-a5b1-606b3650aa1f-a'/%3E      %3C/mask%3E      %3Cpath fill='%23FFF' d='M14.87 6.435L1.435 19.871-12 6.435 1.435-7z' mask='url(%232883de6b-9b56-4ce9-a5b1-606b3650aa1f-b)'/%3E    %3C/g%3E  %3C/g%3E%3C/svg%3E");
  z-index: 1;
  bottom: 40px;
  left: 50%;
  transform: translateX(-50%);
}

@media (max-height: 800px) {
  .banner__arrow {
    display: block;
  }
}

.banner__download-qrcode {
  display: none;
}

.pc .banner__download-item_ios {
  position: relative;
  transition: background-color 0.5s;
}

.pc .banner__download-item_ios>* {
  transition: opacity 0.5s;
}

.pc .banner__download-item_ios .banner__download-qrcode {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  opacity: 0;
  font-size: 14px;
  white-space: nowrap;
}

.pc .banner__download-item_ios .banner__download-qrcode i {
  margin-top: 0;
  display: inline-block;
  vertical-align: middle;
  width: 86px;
  height: 86px;
  background-size: cover;
  background-image: url("data:image/png;base64,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");
}

.pc .banner__download-item_ios:hover {
  background-color: transparent;
}

.pc .banner__download-item_ios:hover>* {
  opacity: 0;
  transition: none;
}

.pc .banner__download-item_ios:hover .banner__download-qrcode {
  transition: all 0.5s;
  opacity: 1;
}

.links {
  animation: a 1s both;
  padding: 72px 0;
  margin: 0 80px 0 112px;
  display: flex;
  justify-content: center;
  overflow: hidden;
}

.links__list {
  display: flex;
  flex-wrap: wrap;
  width: 984px;
}

.links__list li {
  width: 214px;
  height: 180px;
  padding-right: 32px;
  padding-bottom: 32px;
  border-radius: 8px;
  cursor: pointer;
  position: relative;
}

.links__list li a {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
  text-align: center;
  background-color: #fff;
  border-radius: 8px;
  transition: transform 0.3s;
  line-height: 24px;
}

.links__list li a i {
  margin-bottom: 16px;
}

.links__list li a:hover {
  transform: scale(1.1);
}

.links__list a {
  color: rgba(0, 0, 0, 0.9);
}

.h5 .links__list li a:hover {
  transform: none;
}

.download__dialog-mask {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.5);
  overflow-y: hidden;
}

.download__dialog {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 480px;
  background-color: #fff;
  border-radius: 4px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
}

.download__dialog-close {
  position: absolute;
  right: 24px;
  top: 24px;
  cursor: pointer;
  display: inline-block;
  vertical-align: middle;
  width: 24px;
  height: 24px;
  -webkit-mask: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3E  %3Cpath fill-opacity='.9' fill-rule='evenodd' d='M12.25 10.693L6.057 4.5 5 5.557l6.193 6.193L5 17.943 6.057 19l6.193-6.193L18.443 19l1.057-1.057-6.193-6.193L19.5 5.557 18.443 4.5z'/%3E%3C/svg%3E") no-repeat 50% 50%;
  mask: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3E  %3Cpath fill-opacity='.9' fill-rule='evenodd' d='M12.25 10.693L6.057 4.5 5 5.557l6.193 6.193L5 17.943 6.057 19l6.193-6.193L18.443 19l1.057-1.057-6.193-6.193L19.5 5.557 18.443 4.5z'/%3E%3C/svg%3E") no-repeat 50% 50%;
  -webkit-mask-size: cover;
  mask-size: cover;
  background-color: currentColor;
}

.download__dialog-hd {
  font-size: 24px;
  line-height: 29px;
  font-weight: 500;
  padding-top: 48px;
  margin-bottom: 40px;
}

.download__dialog-wrp {
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s;
}

.download__dialog-wrp_show {
  visibility: visible;
  opacity: 1;
}

@media (min-width: 1440px) {
  body {
    font-size: 20px;
  }

  .banner__logo {
    width: 180px;
    height: 56px;
  }

  .banner__update-log {
    width: 500px;
  }

  .banner__update-tag {
    font-size: 12px;
  }

  .banner__download {
    margin-top: 72px;
    margin-right: -32px;
  }

  .banner__download-item {
    margin-right: 32px;
  }

  .banner__download-item i {
    width: 40px;
    height: 40px;
  }

  .banner__entry-extra {
    font-size: 16px;
    width: 217px;
  }

  .banner__entry-extra+.banner__entry-extra {
    margin-left: 32px;
  }

  .pc .banner__download-item_ios .banner__download-qrcode {
    font-size: 16px;
  }

  .links__list li {
    width: 232px;
    height: 196px;
  }

  .links__list {
    width: 1056px;
  }
}

@media (max-width: 1024px) {
  .banner__download {
    margin-right: -16px;
  }

  .banner__download-item {
    margin-right: 16px;
  }
}

@media (max-width: 1176px) {
  .links__list {
    width: 738px;
  }
}

@media (max-width: 930px) {
  .links__list {
    width: 492px;
  }
}

@media (max-width: 760px) {
  body {
    font-size: 15px;
  }

  .banner__logo {
    width: 141px;
    height: 44px;
  }

  .banner__update-log {
    width: 364px;
  }

  .banner__download-item {
    width: 112px;
    height: 112px;
    margin-right: 16px;
    font-size: 13px;
    margin-bottom: 24px;
  }

  .banner__download-item i {
    margin-top: 24px;
  }

  .banner__download {
    width: 384px;
    margin-right: -16px;
    flex-wrap: wrap;
    margin-bottom: -24px;
  }

  .banner__entry-extra {
    width: 170px;
  }

  .pc .banner__download-item_ios .banner__download-qrcode i {
    width: 82px;
    height: 82px;
  }

  .links {
    margin: 0 -32px 0 0;
  }

  .links__list {
    width: 464px;
  }

  .links__list li {
    width: 200px;
    height: 168px;
  }

  .links__list li a i {
    width: 36px;
    height: 36px;
    margin-bottom: 10px;
  }

  .download__dialog-close {
    top: 16px;
    right: 16px;
  }

  .download__dialog {
    width: 310px;
  }

  .download__dialog-hd {
    font-size: 22px;
    line-height: 26px;
    padding-top: 34px;
  }

  .download__btn {
    width: 214px;
  }
}

@media (max-width: 600px) {
  body {
    font-size: 15px;
  }

  .color_change {
    top: 24px;
    right: 16px;
  }

  .banner__logo {
    width: 141px;
    height: 44px;
  }

  .banner__update-log {
    width: 364px;
  }

  .banner__update-log li {
    margin-bottom: 8px;
  }

  .links {
    padding-top: 40px;
  }

  .links__list {
    width: 390px;
  }

  .links {
    margin: 0 auto;
  }

  .links__list {
    min-width: 0;
    margin-right: -24px;
  }

  .links__list li {
    width: 171px;
    height: 143px;
    padding-right: 24px;
    padding-bottom: 24px;
  }

  .links__list li i {
    width: 32px;
    height: 32px;
    margin-bottom: 12px;
  }
}

@media (max-width: 414px) {
  .banner__download {
    width: 256px;
    margin-top: 28px;
    flex-wrap: wrap;
    margin-bottom: -24px;
  }

  .banner__entry-extra {
    width: 128px;
  }

  .banner__entry-extra+.banner__entry-extra {
    margin-left: 8px;
  }

  .banner__entry-extra i {
    margin-right: 0;
  }

  .banner__update-log {
    width: 100%;
    box-sizing: border-box;
    padding: 24px 36px 0;
  }

  .banner__update-log:before {
    left: 36px;
    right: 36px;
    width: auto;
  }

  .banner__entry-extra-wrp {
    padding-top: 30px;
  }

  .links {
    padding: 40px 24px 72px;
  }

  .links__list {
    margin-right: 0;
    width: 100%;
  }

  .links__list li {
    width: 50%;
    box-sizing: border-box;
  }

  .links__list li:nth-child(2n) {
    padding-right: 0;
    padding-left: 12px;
  }

  .links__list li:nth-child(odd) {
    padding-right: 12px;
  }
}

@media (max-width: 370px) {
  .banner__updata-time {
    display: none;
  }

  .links__list li {
    font-size: 13px;
  }
}

@media (max-width: 342px) {
  .download__dialog {
    width: auto;
    left: 16px;
    right: 16px;
    transform: translateY(-50%);
  }
}

@media (max-width: 280px) {
  .links {
    padding: 40px 16px 72px;
  }

  .links__list li:nth-child(2n) {
    padding-right: 0;
    padding-left: 8px;
  }

  .links__list li:nth-child(odd) {
    padding-right: 8px;
  }
}

/* 回到顶部 */
.upFlag {
  height: 100%;
  width: 100%;
  background-color: #f2f5f6;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.12);
  text-align: center;
  line-height: 40px;
  color: #1989fa;
}

/* footer */
.footer-wrp {
  height: 115px;
}

.footer {
  /* position: absolute; */
  text-align: center;
  color: hsla(0, 0%, 100%, 0.7);
  background-color: #fff;
  padding: 40px 0 32px;
  width: 100%;
  bottom: 0;
}

.footer__bd {
  line-height: 1;
}

.footer__links {
  display: inline-flex;
  font-size: 13px;
  margin-bottom: 8px;
  flex-wrap: wrap;
  padding: 0 24px;
  justify-content: center;
  line-height: 1.6;
}

.footer a {
  margin: 0 8px;
}

.footer a:link,
.footer a:visited {
  color: rgba(0, 0, 0, 0.7);
  text-decoration: none;
}

.footer a:hover {
  color: rgba(0, 0, 0, 0.7);
  text-decoration: underline;
}

.footer .footer__record {
  display: block;
  color: #000 !important;
  opacity: 0.5;
  font-size: 12px;
  line-height: 17px;
}

.footer .footer__record:visited {
  color: #000;
}

.footer__copyright {
  color: #000;
  opacity: 0.5;
  font-size: 12px;
  margin-top: 2px;
  line-height: 17px;
}

.graytext {
  color: rgba(0, 0, 0, 0.7);
}
</style>
